// Map specific icons to functional descriptions that explain their purpose
const iconDescriptions = {
  // Font Awesome icons with functional descriptions
  'align left': 'Align text to the left',
  'angle right': 'Navigate to next page or section',
  'arrow circle down': 'Download content',
  'arrow to top': 'Scroll back to top of page',
  'arrow trend up': 'Positive trend indicator',
  'arrow up right': 'Open link in new window',
  'badge check': 'Verified or certified item',
  'ballot check': 'Completed task list',
  bars: 'Open navigation menu',
  bookmark: 'Save item for later reference',
  bullseye: 'Precise target or goal achievement',
  calendar: 'View or select date',
  camcorder: 'Record or view video',
  camera: 'Take or upload photo',
  'caret circle down': 'Expand content panel',
  'caret circle up': 'Collapse content panel',
  'caret down': 'Open dropdown menu',
  'caret right': 'View next item or expand',
  'caret up': 'Close dropdown menu',
  'category leaders gem': 'Top-rated category leader',
  'chart network': 'View data connections or network',
  check: 'Confirmed or completed action',
  'check square': 'Selected or completed item',
  'chevron down': 'Expand section below',
  'chevron left': 'Navigate to previous page',
  'chevron right': 'Navigate to next page',
  'chevron up': 'Collapse section above',
  circle: 'Unselected option',
  'circle info': 'View important information',
  'circle user': 'View user profile details',
  'clipboard list': 'View task list or checklist',
  cog: 'Access settings or configuration',
  comment: 'View or add comments',
  'comment minus': 'Remove or hide comment',
  'comment plus': 'Add new comment',
  crown: 'Premium or featured status',
  'dollar sign': 'Price or cost information',
  'euro sign': 'Price in Euro currency',
  envelope: 'Send email or view messages',
  'exclamation circle': 'Warning notification',
  'exclamation triangle': 'Error or critical alert',
  'external link': 'Link opens in new window',
  'facebook square': 'Visit Facebook page',
  film: 'Watch video content',
  folder: 'Open file folder',
  gem: 'Premium or exclusive feature',
  google: 'Sign in with Google',
  heart: 'Add to favorites or liked items',
  images: 'View image gallery',
  'info circle': 'View additional information',
  instagram: 'Visit Instagram page',
  'layer group': 'View multiple data layers',
  lightbulb: 'Tip or helpful suggestion',
  link: 'Create or view hyperlink',
  linkedin: 'Visit LinkedIn page',
  minus: 'Remove item or decrease value',
  'navigate next': 'Go to next item',
  'navigate previous': 'Go to previous item',
  'pen clip': 'Edit content or write note',
  phone: 'Make phone call or contact by phone',
  play: 'Start media playback',
  'play circle': 'Start media playback',
  plus: 'Add new item or increase value',
  'power off': 'Log out or turn off',
  question: 'Get help or view FAQ',
  'question circle': 'Get help or view FAQ',
  'quote left': 'Start of testimonial or quote',
  'quote right': 'End of testimonial or quote',
  search: 'Search for content',
  'share alt': 'Share content with others',
  shapes: 'View categories or types',
  'shield alt': 'Security or protection feature',
  signal: 'Connection strength indicator',
  sitemap: 'View site structure',
  'sliders h': 'Adjust horizontal settings',
  'sliders v': 'Adjust vertical settings',
  'sort amount down': 'Sort in descending order',
  sparkles: 'New or featured item',
  star: 'Star for rating value indicator',
  'star half 1': 'Half star rating (filled part)',
  'star half 2': 'Half star rating (empty part)',
  'star half': 'Half star rating',
  'sterling sign': 'Price in British Pounds',
  stopwatch: 'Time duration or deadline',
  'sync alt': 'Refresh or reload content',
  'thumbs down': 'Negative rating or dislike',
  'thumbs up': 'Positive rating or like',
  times: 'Close or cancel',
  'times circle': 'Error or remove item',
  'trash can': 'Delete or remove permanently',
  'usd circle': 'Price in US Dollars',
  'user circle': 'User account profile',
  'user group solid': 'Team or group members',
  'user shield': 'Administrator or protected account',
  user: 'User profile outlined icon',
  users: 'Multiple users or group',
  'x twitter': 'Visit Twitter/X page',
  xmark: 'Close or cancel action',
  'yen sign': 'Price in Japanese Yen',

  // Software category icons - describe their purpose rather than appearance
  accounting: 'Find accounting software',
  'applicant tracking': 'Find applicant tracking software',
  'book reader': 'Find reading or documentation software',
  'business management': 'Find business management software',
  'call center': 'Find call center software',
  'church management': 'Find church management software',
  'construction estimating': 'Find construction estimating software',
  consulting: 'Find consulting software',
  crm: 'Find Customer Relationship Management software',
  'customer service': 'Find customer service software',
  distribution: 'Find distribution software',
  'employee monitoring': 'Find employee monitoring software',
  'employee scheduling': 'Find employee scheduling software',
  'facility management': 'Find facility management software',
  'field service management': 'Find field service management software',
  'human resources': 'Find HR software',
  'interactive article': 'View interactive content',
  'inventory management': 'Find inventory management software',
  'license management': 'Find license management software',
  'live chat': 'Find live chat software',
  'membership management': 'Find membership management software',
  okr: 'Find Objectives and Key Results software',
  'point of sale': 'Find point of sale software',
  pricetag: 'Price information',
  pricing: 'View pricing details',
  procurement: 'Find procurement software',
  productivity: 'Find productivity software',
  'project management': 'Find project management software',
  reporting: 'Find reporting software',
  rolodex: 'Find contact management software',
  scheduling: 'Find scheduling software',
  'time tracking': 'Find time tracking software',
  tools: 'Find tools and utilities',
  training: 'Find training software',
  'warehouse management': 'Find warehouse management software',
  'work order': 'Find work order software',

  // GetApp specific icons with functional descriptions
  analysis: 'View data analysis',
  'author chevron': 'Expand author details',
  billing: 'View billing details',
  caret: 'Expand or collapse menu',
  category: 'Browse by category',
  chat: 'Start or view conversation',
  clock: 'View time-related information',
  compare: 'Compare multiple items',
  content: 'Editable content pencil indicator',
  'customer loyalty': 'View customer loyalty information',
  'data vis': 'View data visualization',
  email: 'Send or view email',
  'getapp logo': 'Go to GetApp homepage',
  leads: 'View or manage sales leads',
  'logo square': 'Getapp teal diamonds brand logo ',
  megaphone: 'View announcement or promotion',
  paperclip: 'Attach file',
  report: 'View or generate report',
  reservation: 'Make or view reservation',
  'schedule calendar': 'View calendar scheduling',
  'schedule people': 'Manage people scheduling',
  subtract: 'Remove or decrease',
  tasks: 'View task list',
  usd: 'Price in US Dollars',
  'web analytics': 'View web analytics data',
}

export default iconDescriptions
